<template>
  <el-dialog
    id='realNameDialog'
    :title="title"
    @close="closeDialog"
    :visible.sync="isShow"
    width="620px"
    :close-on-click-modal='false'
    :close-on-press-escape='false'
  >
    <div id="realName" v-if="active=='1'">
      <div class="" style="text-align:left;padding: 0px 0px 10px 0px;">
        <el-alert class="alert" title="" type="info" show-icon :closable="false" style="padding: 8px">
          <span>温馨提示：为了线上打款准确性，请填写支付宝账号对应的真实姓名</span>
        </el-alert>
      </div>
      <el-form label-width="150px"  class="demo-ruleForm y-mt-30" :model="form" ref="form" :rules="formRules">
        <el-form-item prop="name" label="支付宝真实姓名" class="name-input">
          <el-input v-model="form.name" placeholder="请输入姓名" :maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label-width="0" class="form-btn">
          <el-button type="primary" class="y-w-100" @click="toVerifySucceeded">确认</el-button>
        </el-form-item>
      </el-form>
    </div>
    <verify-succeeded activeType='showAccount' :authCode="authCode" @close="closeDialog"  @toSetting='toSetting' v-else></verify-succeeded>
  </el-dialog>
</template>

<script>
import VerifySucceeded from './verifySucceeded.vue';

import { 
  alipayAuthToUpdateMallByQuicksettlementApi,//完成支付宝授权并写入店铺表
} from '../../../api/quickIndemnity/quicksettlement';
export default {
  name: 'realNameDialog',
  components:{
    VerifySucceeded
  },
  props: {
     data: {
      type: Object,
      default: {}
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: '支付宝已授权请填写支付宝账号对应的姓名',
      isShow: this.value,
      active:'1',
      authCode: this.data.state || '',
      form: {
        name: '',
      },
      formRules: {
        name: [
          { required: true, message: '姓名不能为空', trigger: ['change', 'blur'] },
        ],
      },
    }
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  created() {
  },
  mounted() {},
  methods: {
    toSetting(){
      this.isShow = false;
      this.$emit('close');
      this.$parent.openCollecAccount();
    },
    closeDialog() {
      this.isShow = false;
      this.$emit('close');
    },
    toVerifySucceeded(){
      let info = '?authCode='+this.data.state+'&alipayAuthCode='+this.data.auth_code+'&alipayRealName='+this.form.name;
      alipayAuthToUpdateMallByQuicksettlementApi(info).then(res => {
         console.log(res)
        if (res.status == 200 && res.message == 'ok') {
          // {"code":1,"data":"支付宝授权成功","errorCode":0,"time":"2023-02-28 19:49:47","message":"ok","status":200}
          this.active = '2';
          // this.$message.success(res.data||'授权成功');
        } else {
          this.$message.error(res.error||'授权失败');
        }
      });
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss">
#realNameDialog{

  .el-dialog__body{
    padding: 12px 20px 40px 20px;
  }
  .demo-ruleForm{
    .el-form-item--small.el-form-item{
      width: 400px;
      margin: 0 auto 18px auto;
    }
    .name-input .el-input{
      width: 250px;
    }
    .form-btn{
      display: block;
      margin-left: 0;
      margin-top: 40px!important;
      text-align: center;
    }
  }
}
</style>
